import { render, staticRenderFns } from "./ColorConversion.vue?vue&type=template&id=163f6d76"
import script from "./ColorConversion.vue?vue&type=script&lang=js"
export * from "./ColorConversion.vue?vue&type=script&lang=js"
import style0 from "./ColorConversion.vue?vue&type=style&index=0&id=163f6d76&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports